import { ListItem } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

interface SectionHeaderProps {
  label: string;
  hasTopMargin?: boolean;
}

export function SectionHeader(props: SectionHeaderProps) {
  const { label, hasTopMargin = false } = props;

  return (
    <ListItem sx={{ py: 0.5, px: 2, mt: hasTopMargin ? 1 : 0 }}>
      <Text
        color="text.secondary"
        sx={{ fontWeight: 600, textTransform: "uppercase" }}
        variant="caption"
      >
        {label}
      </Text>
    </ListItem>
  );
}
